import { render } from "./AuthProviderWarningBanners.vue?vue&type=template&id=01548f0d&scoped=true&ts=true"
import script from "./AuthProviderWarningBanners.vue?vue&type=script&lang=ts"
export * from "./AuthProviderWarningBanners.vue?vue&type=script&lang=ts"

import "./AuthProviderWarningBanners.vue?vue&type=style&index=0&id=01548f0d&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01548f0d"]])

export default __exports__